import React from 'react';
import PropTypes from 'prop-types';

const ConfirmationPath = ({ fill }) => {
  return (
    <path
      fill={fill}
      d="M3 16C3 8.831 8.832 3 16 3c7.169 0 13 5.831 13 13s-5.831 13-13 13C8.832 29 3 23.169 3 16zm17.889-5.31l-7.161 8.535-2.85-2.39a.931.931 0 0 0-1.305.116l-.597.713a.923.923 0 0 0 .113 1.306l4.272 3.585a.926.926 0 0 0 .675.21l.002.002a.93.93 0 0 0 .63-.33l8.355-9.957a.925.925 0 0 0-.113-1.308l-.713-.599a.927.927 0 0 0-1.308.117z"
    />
  );
};

ConfirmationPath.propTypes = {
  fill: PropTypes.string,
};

export default ConfirmationPath;



// WEBPACK FOOTER //
// ./src/icon/svgs/feedback/confirmation.jsx